import {
  TechnicianKycStatus,
  TechnicianPosition,
  TechnicianStatus,
  TechnicianType,
} from '../utils/entities/type';
import { get, post } from './https';

const UpdatePair = async (
  helperId: string,
  technicianId: string,
): Promise<number> => {
  const url = `/api/v1/admin/helper/pair`;
  const result = await post(url, { technicianId, helperId });
  if (result.status == 200) {
    return 200;
  } else {
    throw Error('Failed To Update KYC Status');
  }
};

const UnpairedTech = async (helperId: string): Promise<number> => {
  const url = `/api/v1/admin/helper/unpair/${helperId}`;
  const result = await post(url);
  if (result.status == 200) {
    return 200;
  } else {
    throw Error('Failed To Update KYC Status');
  }
};

const GETHelperTechnicians = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
  type,
  position,
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
  type?: TechnicianType | any;
  position?: 'TBA';
}): Promise<any> => {
  // Initialize the base URL
  let url = `/api/v1/admin/unpaired-technicians/list/?limit=${limit}&page=${page}`;

  console.log('TYPE', type);
  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    // assuming 'name' is the default field, you can change it if needed
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    // assuming 'ASC' is the default sort order
    url += `&sortOrder=${sortOrder}`;
  }

  if (type) {
    url += `&type=${type}`;
  }
  if (position) {
    url += `&position=${position}`;
  }
  const response = await get(url); // Use the previously defined `get` function

  if (response.status == 200) {
    return response.data; // If status is true, return the user data
  } else {
    throw new Error('Failed to fetch users');
  }
};

export { UpdatePair, UnpairedTech, GETHelperTechnicians };
